const { prop } = require('ramda');
module.exports = (value) => (prop('userId')(value) ? 'Yes' : 'No');
